module.exports = __webpack_public_path__ + "static/media/javascript.20ee3998.svg";